import React from "react";
import { Download, FileDown, Lock, Printer, QrCode, RefreshCw, Unlock } from "lucide-react";
import { toast } from "sonner";

import { baixarPdfCartoes, baixarPngMesa, bloquear, rotacionar } from "./api";
import { imprimirNaTermica } from "./imprimirNaTermica";

const BOTAO = "h-10 rounded-xl border border-border text-xs font-bold flex items-center justify-center gap-1.5 hover:bg-muted disabled:opacity-50";

// Botões do QR de uma mesa: imprimir na impressora do caixa (fila de
// impressão do sistema), baixar imagem/PDF, bloquear e trocar o código.
export default function AcoesQrMesa({ mesa, pronto, onMudou, onRecarregar, onAbrirTodas }) {
  const baixar = async (tipo) => {
    try {
      if (tipo === "pdf") await baixarPdfCartoes([mesa.id]);
      else await baixarPngMesa(mesa);
    } catch {
      toast.error(tipo === "pdf" ? "Não consegui gerar o PDF." : "Não consegui baixar a imagem.");
    }
  };

  const trocarCodigo = async () => {
    const confirmado = window.confirm(
      `Gerar um código novo para a ${mesa?.nome}?\n\nO QR Code que está colado nela para de funcionar na hora e precisa ser impresso de novo.`,
    );
    if (!confirmado) return;
    try {
      await rotacionar(mesa.id);
      toast.success("Código trocado. Imprima o cartão novo.");
      onRecarregar();
    } catch {
      toast.error("Não consegui trocar o código.");
    }
  };

  const alternarBloqueio = async () => {
    try {
      await bloquear(mesa.id, !mesa.bloqueada);
      onMudou({ ...mesa, bloqueada: !mesa.bloqueada });
      toast.success(mesa.bloqueada ? "Mesa liberada para pedidos." : "Pedidos desta mesa bloqueados.");
    } catch {
      toast.error("Não consegui alterar o bloqueio.");
    }
  };

  return (
    <div className="px-5 pb-5 space-y-2">
      <button
        type="button"
        onClick={() => imprimirNaTermica([mesa.id])}
        disabled={!pronto}
        data-e2e="qr-imprimir-mesa"
        className="w-full h-11 rounded-xl bg-primary text-primary-foreground font-bold flex items-center justify-center gap-2 disabled:opacity-50"
      >
        <Printer className="w-4 h-4" /> Imprimir na impressora
      </button>
      <div className="flex gap-2">
        <button type="button" onClick={() => baixar("png")} disabled={!pronto} className={`flex-1 ${BOTAO}`}
                data-e2e="qr-baixar-imagem">
          <Download className="w-3.5 h-3.5" /> Baixar imagem
        </button>
        <button type="button" onClick={() => baixar("pdf")} disabled={!pronto} className={`flex-1 ${BOTAO}`}
                data-e2e="qr-baixar-pdf">
          <FileDown className="w-3.5 h-3.5" /> Baixar PDF
        </button>
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={alternarBloqueio}
          disabled={!mesa}
          className={`flex-1 ${BOTAO} ${mesa?.bloqueada ? "!border-red-500/40 text-red-500 hover:!bg-red-500/10" : ""}`}
        >
          {mesa?.bloqueada ? <Lock className="w-3.5 h-3.5" /> : <Unlock className="w-3.5 h-3.5" />}
          {mesa?.bloqueada ? "Bloqueada" : "Liberada"}
        </button>
        <button type="button" onClick={trocarCodigo} disabled={!mesa} className={`flex-1 ${BOTAO}`}>
          <RefreshCw className="w-3.5 h-3.5" /> Novo código
        </button>
      </div>
      {onAbrirTodas ? (
        <button
          type="button"
          onClick={onAbrirTodas}
          className="w-full text-[11px] text-muted-foreground hover:text-foreground underline underline-offset-2 pt-1 flex items-center justify-center gap-1"
        >
          <QrCode className="w-3 h-3" /> QR Codes de todas as mesas
        </button>
      ) : null}
    </div>
  );
}
